import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
//import { CartProvider, useCart } from 'react-use-cart';
//import { useCart } from '../../Context/ECatalogContext';
import { BiCartAlt } from "react-icons/bi";
import {
    getAzureConfig,
    LoginConfiguration,
  } from "../../Services/ConfigurationService";
  
import { Breadcrumb, Layout, Menu, Button,Badge,Avatar,Popover, Modal } from 'antd';
import { ButtonNavigation } from "../ButtonNav/ButtonNavigation";
import { ButtonNavigationDropdown } from "../ButtonNav/ButtonNavigationDropdown";
import { useUserContext } from "../../Context/UserContext";
import { useSessionContext } from "../../Context/AuthContext";
import { IoLogOutSharp, IoMailOutline, IoPersonOutline } from "react-icons/io5";
import Cookies from "universal-cookie";
import { clearLocalStorageOnLogout } from "../../Helper/localStoreFunction";
import type { MenuProps } from 'antd';
import { useMsal } from "@azure/msal-react";
import { useTranslation } from "react-i18next";
import { useECatalogContext } from "../../Context/ECatalogContext";
import { useCart } from "../../Context/CartContext";
const { Header, Content, Footer, Sider  } = Layout;


// import logo from '../../assets/logotrcs_150px_new1.jpg';


interface Props {
    //responeConfig: any;
  }
  interface AzureConfig {
    c: string;
    s: string;
    w: string;
  }
export const ECatalogNavigation = (props: Props) => {
    const [userData, setUserData] = useUserContext();
    const [popOverClick, setPopOverClick] = useState<boolean>(false);
    const [shortNameUser, setShortNameUser] = useState<string>("");
    const [sessionState, setSessionState] = useSessionContext();
    const [responeConfig, setResponeConfig] = useState<any>();
    const [auzreConfig, setAuzreConfig] = useState<AzureConfig>();
    const { instance, accounts } = useMsal();
    const history = useHistory();
    const cookies = new Cookies();
    const checkEcatalog = useECatalogContext();
    const [isAuthorize, setIsAuthorizeo] = useState(true);
    const [isEditECatalog, setIsEditECatalog] = useState(true);
    const { t } = useTranslation(["translation"]);
    const menuItem = [
        { key: 1, label: "หน้าแรก" },
        //{ key: 2, label: "ประวัติการขอซื้อ" },
        // { key: 3, label: "คู่มือการใช้งาน" }
    ]
    // const {
    //     //isEmpty,
    //     totalItems,
    // } = useCart();
    const { totalItems } = useCart();
    useEffect(() => {
        fetchCon().then(([responeConfig, reponseAzureConfig]) => {
          setAuzreConfig(reponseAzureConfig);
          setResponeConfig(responeConfig);
          if (
            responeConfig?.titleWeb !== "" &&
            responeConfig?.titleWeb !== undefined &&
            responeConfig?.titleWeb != null
          ) {
            document.title = responeConfig?.titleWeb;
          }
          if (
            responeConfig?.pathFavicon !== "" &&
            responeConfig?.pathFavicon !== undefined &&
            responeConfig?.pathFavicon != null
          )
            document
              .querySelector('link[rel="shortcut icon"]')
              ?.setAttribute("href", responeConfig?.pathFavicon);
        });
      }, []);
    useEffect(() => {
        if (userData) {
          initialNameUser();
        }
      }, [userData]);
    useEffect(() => {
      if (checkEcatalog.roleData  != null)
      {
          setIsAuthorizeo(checkEcatalog.canAccess);
          setIsEditECatalog(checkEcatalog.canEdit);
      }
      console.log(checkEcatalog);
  }, [checkEcatalog]);
      const initialNameUser = () => {
        if (userData) {
          let name = userData.NameEn || "";
          const fullName: any[] | ["", ""] = name.split(" ");
          let firstName = "";
          let lastName = "";
          for (let i = 0; i < fullName.length; i++) {
            if (i === 0) {
              firstName = fullName[i].slice(0, 1).toUpperCase();
            }
            if (i === 1) {
              lastName = fullName[i].slice(0, 1).toUpperCase();
            }
          }
          setShortNameUser(firstName + lastName);
        }
      };
      const fetchCon = async () => {
        
        var responeConfig = await LoginConfiguration();
        const reponseAzureConfig = await getAzureConfig();
        return [responeConfig, reponseAzureConfig];
      };
    // const userPopupContent = () => {
    //     return (
    //       <div className="main-user-popup-content">
    //         <div className="user-popup-content">
    //           <div className="user-popup-content-display">
    //             <IoPersonOutline className="icon-margin-top" />
    //             <p className="text-account-name icon-margin-left" style={{ fontSize: '20px' }}>
    //               {userData?.NameEn}
    //             </p>
    //           </div>
    //           <div className="user-popup-content-display">
    //             <IoMailOutline className="icon-margin-top " />
    //             <p className="text-account-mail icon-margin-left" style={{ fontSize: '20px' }}>
    //               {userData?.Email}
    //             </p>
    //           </div>
    //         </div>
    //         <div className="popup-button-box">
    //           {/* change Pass */}
    //           {canEditProfile && (
    //             <div
    //               className="popup-container"
    //               onClick={handleOpenEditProfileModal}
    //             >
    //               <div className="circle">
    //                 <BsFillPersonFill />
    //               </div>
    //               <p className="text-logout">{t("Edit Profile")}</p>
    //             </div>
    //           )}
    //           {isWolf && (
    //             <div
    //               className="popup-container"
    //               onClick={handleOpenChangePasswordModal}
    //             >
    //               <div className="circle">
    //                 <svg
    //                   width="13"
    //                   height="13"
    //                   viewBox="0 0 19 19"
    //                   fill="none"
    //                   xmlns="http://www.w3.org/2000/svg"
    //                 >
    //                   <path
    //                     d="M12.375 0.515625C11.4374 0.515648 10.5124 0.731471 9.6716 1.14638C8.83081 1.56129 8.09679 2.16415 7.52639 2.90828C6.95599 3.65241 6.56452 4.51784 6.38229 5.43756C6.20005 6.35727 6.23195 7.30659 6.4755 8.212L0.515625 14.1719V18.4844H4.82812V16.3281H6.98438V14.1719H9.14062L10.7937 12.5188C11.3098 12.6596 11.8403 12.7315 12.375 12.7344C13.9953 12.7344 15.5493 12.0907 16.695 10.945C17.8407 9.79925 18.4844 8.24531 18.4844 6.625C18.4844 5.00469 17.8407 3.45075 16.695 2.30502C15.5493 1.15929 13.9953 0.515625 12.375 0.515625Z"
    //                     fill="black"
    //                     stroke="black"
    //                     stroke-width="0.5"
    //                     stroke-linecap="round"
    //                     stroke-linejoin="round"
    //                   />
    //                 </svg>
    //               </div>
    //               <p className="text-logout">{t("Change Password")}</p>
    //             </div>
    //           )}
    //           <div
    //             className="popup-container"
    //             onClick={() => signOutClickHandler(instance)}
    //           >
    //             <div className="circle">
    //               <IoLogOutSharp />
    //             </div>
    //             <p className="text-logout">{t("Logout")}</p>
    //           </div>
    //         </div>
    //       </div>
    //     );
    //   };
    const NavbarDesktop = () => {
      return (
        <>
          <div
            className="logo-container desktop"
            onClick={() => history.push("/")}
          >
            <img
              style={{
                width: `${responeConfig?.cssConfig?.width}`,
                height: "70px",
                background: "white",
              }}
              className="img-logo"
              src={responeConfig?.pathLogoNav}  
              alt="logo"
            />
          </div>
          <div
            style={{
              alignContent: "center",
              width: 1000,
              fontSize: "x-large",
              color: "black",
            }}
          >
            {/* ระบบจัดซื้อจัดจ้างอิเล็กทรอนิกส์ e-Procurement สภากาชาดไทย */}
          </div>
          <div className="button-navbar-container desktop">
            <div>
              {
                isEditECatalog && !checkEcatalog.isSystemClosed && (

                  <button className="button-nav -active" id="Settings"  onClick={() => { history.push(`/cart`); }}>
                    <Badge count={totalItems} >
                        <BiCartAlt />
                    </Badge>
                </button>
                )
              }
                
            </div>
          </div>
          <div className="profile-container desktop">
            <Popover
              placement="bottomRight"
              content={userPopupContent}
              trigger="click"
              visible={popOverClick}
              onVisibleChange={handleClickChange}
              overlayInnerStyle={{ borderRadius: "6px" }}
            >
              <div className="profile-button">
                <p className="profile-name">{shortNameUser}</p>
              </div>
            </Popover>
            {/* <div className="profile-button">
                <p className="profile-name">{shortNameUser}</p>
              </div> */}
          </div>
        </>
      );
    };
    const userPopupContent = () => {
      return (
        <div className="main-user-popup-content">
          <div className="user-popup-content">
            <div className="user-popup-content-display">
              <IoPersonOutline className="icon-margin-top" />
              <p
                className="text-account-name icon-margin-left"
                style={{ fontSize: "20px" }}
              >
                {userData?.NameEn}
              </p>
            </div>
            <div className="user-popup-content-display">
              <IoMailOutline className="icon-margin-top " />
              <p
                className="text-account-mail icon-margin-left"
                style={{ fontSize: "20px" }}
              >
                {userData?.Email}
              </p>
            </div>
          </div>
          <div className="popup-button-box">
            {/* change Pass */}
            <div
              className="popup-container"
              onClick={() => signOutClickHandler(instance)}
            >
              <div className="circle">
                <IoLogOutSharp />
              </div>
              <p className="text-logout">{t("Logout")}</p>
            </div>
          </div>
        </div>
      );
    };
    const signOutClickHandler = async (instance: any) => {
      var respone = await LoginConfiguration();
      const baseurl = window.location.origin.toString();
      cookies.remove("GuidVerify");
      clearLocalStorageOnLogout();
      setSessionState({ ...sessionState, isAuthenticated: false });
      //AzureLogout
      if (respone.type === "LoginAzure") {
        const logoutRequest = {
          account: instance.getAccountByHomeId(accounts[0]?.homeAccountId),
          postLogoutRedirectUri: `${baseurl}/login`,
        };
        await instance.logoutRedirect(logoutRequest);
      }
      setPopOverClick(false);
  
      //GoogleLogout
      // googleAuth?.signOut();
    };
    const handleClickChange = (visible: boolean) => {
        //setPopOverHover(false);
        setPopOverClick(visible);
      };

      const onMenuClick: MenuProps['onClick'] = e => {
        if (e.key === "1" )
          history.push(`/ECatalog`);
      };

      return (
        <>
          {sessionState.isAuthenticated /*&& !shouldHideNavbar*/ &&(
            <>
              <div
                className={`navbar-container -active`}
                style={{
                  backgroundColor: responeConfig?.pathNavbarColor,
                  // borderBottom: "4px solid #red",
                  //borderBottom: "4px solid #c95558"
                }}
              >
                
                {NavbarDesktop()}
               
                
              </div>
              <div className="div-site-navigation-main" >
                     <Menu style={{display: "block"}}
                         className="site-navigation-main"
                         mode="horizontal"
                         //defaultSelectedKeys={["1"]}
                         onClick={onMenuClick}
                         items={menuItem}
                     />
                 </div>
            </>
          )}
        </>
      );

    // return (
    //     <Header style={{ height: "100%" }} className="site-header">
    //             <div>
    //                 <div className="site-identity">
    //                     <a href="/Ecatalog">
    //                         <img
    //                             src={logo}
    //                             alt="ระบบจัดซื้อจัดจ้างอิเล็กทรอนิกส์ e-Procurement สภากาชาดไทย"
    //                         />
    //                     </a>
    //                     <h1>
    //                         ระบบจัดซื้อจัดจ้างอิเล็กทรอนิกส์ e-Procurement สภากาชาดไทย
    //                     </h1>
    //                 </div>
    //                 <div className="site-navigation">
    //                     <nav className="">
    //                         <ul className="nav">
    //                             <li style={{marginRight: "10px", cursor:"pointer"}} onClick={() => { history.push(`/cart`); } }>
    //                                 <Badge count={totalItems} >
    //                                 <Avatar shape="square" size="large" icon={<BiCartAlt />} />
    //                                 </Badge>
                                    
    //                             </li>
    //                             <li>
    //                                 {/* <a href="#">เข้าสู่ระบบ</a> */}
    //                                 <Button
    //                                     type="primary"
    //                                     shape="round"
    //                                     size={"large"}
    //                                     className="login-button"
    //                                     onClick={() => { window.location.href = '/login' }}
    //                                 >
    //                                     AD
    //                                 </Button>
    //                             </li>
    //                         </ul>
    //                     </nav>
    //                 </div>
    //             </div>
    //             <div className="div-site-navigation-main" >
    //                 <Menu style={{display: "block"}}
    //                     className="site-navigation-main"
    //                     mode="horizontal"
    //                     defaultSelectedKeys={["1"]}
    //                     items={menuItem}
    //                 />
    //             </div>
    //         </Header>

    // )

}